import { AfterViewInit, Component, DoCheck, Input, OnInit } from '@angular/core';

import { DataTableComponent } from '../../controls/data-table/data-table.component';
import { FormActionsThroughEmitters, TipoObjetoParaPermisos } from 'src/app/models/general.enum';
import { GeneralFormComponent } from '../../controls/general-form/general-form.component';
import { StaticData } from "../../../helpers/static-data";

@Component({
  selector: 'app-tubicacion-fisica-expediente',
  templateUrl: './tubicacion-fisica-expediente.component.html',
  styleUrls: ['./tubicacion-fisica-expediente.component.css']
})
export class TUbicacionFisicaExpedienteComponent extends GeneralFormComponent implements OnInit, AfterViewInit, DoCheck {

  @Input() detalleExpediente: any;
  urlReturn: any = null;

  // Fase 2 Archivo Fisico: ultimo valor visto de HabilitarArchivoFisico para reaccionar a cambios (ngDoCheck).
  private ultimoHabilitarArchivoFisico: boolean | null = null;
  private habilitarArchivoFisicoConfigurado: boolean = false;
  private datosArchivoFisicoEdicion: any = null;
  private idArchivoFisicoSeleccionado: any = null;
  private edicionArchivoFisicoPendiente: boolean = false;
  private edicionArchivoFisicoEnProceso: boolean = false;



  public OnInitEnd() {

    // Insercion de permisos
    //debugger;
    this.modelo.modeloVirtual.UsuarioAutenticado = StaticData.Usuario.IdUsuario;
    this.OnCreatePermissionsConfig();

    // Fase 2 Archivo Fisico: HabilitarArchivoFisico llega como HiddenField (Value:"false" por defecto
    // en el JSON de pagina); si por alguna razon no se pobla, se asume false (flujo legado intacto).
    if (!this.modelo.modeloVirtual) {
      this.modelo.modeloVirtual = {};
    }

    this.habilitarArchivoFisicoConfigurado = this.ObtenerHabilitarArchivoFisicoConfigurado();
    this.modelo.modeloVirtual.HabilitarArchivoFisico = this.habilitarArchivoFisicoConfigurado;

    this.ultimoHabilitarArchivoFisico =
      this.modelo.modeloVirtual.HabilitarArchivoFisico;

    this.ActualizarVisibilidadArchivoFisico();

    if (this.utility.ParentDetailsItem) {

      this.utility.ReturnParentDetailsItem = this.utility.ParentDetailsItem;
      /**
       * Inicio Edward Morales 02/03/2032
       * Valida el nombre de la página entrante para posterior Retorno commandBar
       * si no existe la propiedad continúa proceso anterior (DetalleExpediente)
       */
      if(this.utility.ParentDetailsItem.Pagina){
        this.urlReturn = this.utility.ParentDetailsItem.Pagina
      }
      this.utility.ParentDetailsItem = null;
      const DataTables_BusquedaExpediente = this.Pagina.ConfigPage.Controls.find(x => { return x.Name == 'DataTables_BusquedaExpediente' && x.Activo == true });
      if (DataTables_BusquedaExpediente) {
        DataTables_BusquedaExpediente.Activo = false;
      }
      else {
        const IdExpediente = this.Pagina.ConfigPage.Controls.find(x => { return x.Name == 'IdExpediente' && x.Activo == true });
        IdExpediente.Activo = false;
      }
    }

    this.preSaveEmitter.subscribe(event => {
      //debugger;
      if (this.utility.ReturnParentDetailsItem) {
        this.modelo.modelo.IdExpediente = this.utility.ReturnParentDetailsItem.IdExpediente;
      }

		});

    // Fase 2 Archivo Fisico: GetSaveModel() solo envia this.modelo.modelo (nunca modeloVirtual), por lo
    // que los campos parametrizados deben copiarse explicitamente antes de guardar.
    this.preSaveEmitter.subscribe(() => {
      this.ConsolidarDatosArchivoFisico();
    });

    // Fase 2 Archivo Fisico: al editar un registro ya parametrizado, reconstruye los campos virtuales
    // (Estante/Cara/Entrepano/Caja legados ya son numericos como String) para precargar las cascadas.
    this.postEditEmitter.subscribe(() => {
      this.edicionArchivoFisicoPendiente = true;
      this.ProcesarEdicionArchivoFisico();
    });
    /// Fin de modificacion Marlon Granda 29_11_2020
    this.postSaveEmitter.subscribe((modelo) => {
      //debugger;
      const idExpediente = this.modelo.modelo.IdExpediente ||
        (this.utility.ReturnParentDetailsItem && this.utility.ReturnParentDetailsItem.IdExpediente);
      this.modelo.modelo.Caja = null;
      this.modelo.modelo.Cara = null;
      this.modelo.modelo.Carpeta = null;
      this.modelo.modelo.Entrepano = null;
      this.modelo.modelo.Estante = null;
      this.modelo.modelo.FechaFinal = null;
      this.modelo.modelo.FechaInicial = null;
      this.modelo.modelo.Folios = null;
      this.modelo.modelo.IdUbicacionFisicaExpediente = null;
      this.modelo.modelo.Observaciones = null;
      this.modelo.modelo.CurrentItemIndex = null;
      this.modelo.modelo.PkValue = 0;
      this.modelo.modelo.IdExpediente = idExpediente;

      this.SetModelToControls();
      this.ActualizarBodegaDespuesDeGuardar();
      if (this.commandBar) {
        this.commandBar.SetHiddenOption(false, 'Type', 'New');
      }
    });

  }

  // Agrega metdo de validacion de permisos Edwin Alonso 09022021

  // Fase 2 Archivo Fisico: reacciona a cambios en tiempo de ejecucion del flag (ademas del valor inicial).
  ngDoCheck() {
    const modeloVirtual =
      this.modelo && this.modelo.modeloVirtual
        ? this.modelo.modeloVirtual
        : null;

    if (!modeloVirtual) {
      return;
    }

    const esNuevo = !this.modelo.modelo || !this.modelo.modelo.IdUbicacionFisicaExpediente;
    if (esNuevo && this.habilitarArchivoFisicoConfigurado &&
      !this.ConvertirABooleano(modeloVirtual.HabilitarArchivoFisico)) {
      modeloVirtual.HabilitarArchivoFisico = true;
    }

    const habilitado =
      this.ConvertirABooleano(
        modeloVirtual.HabilitarArchivoFisico
      );

    if (this.ultimoHabilitarArchivoFisico !== habilitado) {
      this.ultimoHabilitarArchivoFisico = habilitado;
      modeloVirtual.HabilitarArchivoFisico = habilitado;

      this.ActualizarVisibilidadArchivoFisico();
    }

    this.ProcesarEdicionArchivoFisico();
  }

  public OnCreatePermissionsConfig() {
    this.permissionsConfig = {
      TipoObjetoParaPermiso: TipoObjetoParaPermisos.Documento,
      Pagina: this.Pagina,
      clear: true,
      expediente: null,
      CreatedRowConfig: {},
    };
    this.RaiseFormEvent("OnCreatePermissionsConfig", true);
  }
  public OnSelectedComboBox(item: any, controlName: string, config: any) {
    if(controlName == 'IdExpediente')
    {
      try {
        this.SetExpediente(item);
        this.comboBoxManager.ExecuteCascading(item, controlName, config);
      } catch (error) {
        this.utility.logger.LogError(error, null, {
          componentName: this.componentName,
          method: "OnSelectedComboBox",
          controlName: controlName,
        });
        this.utility.VerModalDanger().then((data) => { });
      }
    }
    else if (controlName == 'IdArchivoFisico') {
      try {
        this.SetBodegaArchivoFisico(item);
      } catch (error) {
        this.utility.logger.LogError(error, null, {
          componentName: this.componentName,
          method: "OnSelectedComboBox",
          controlName: controlName,
        });
        this.utility.VerModalDanger().then((data) => { });
      }
    }
    else if (controlName == 'EsCajaNueva') {
      this.modelo.modeloVirtual.EsCajaNueva = this.ConvertirABooleano(
        item && item.EsCajaNueva !== undefined ? item.EsCajaNueva : item
      );
      this.ActualizarVisibilidadCajaNueva();
    }
    else if (controlName == 'NumeroCajaDestino') {
      this.SetCajaDestino(item);
    }
  }


  public NgAfterViewInitEnd() {
    if (this.utility.ReturnParentDetailsItem) {
      setTimeout(() => {

        if (this.commandBar)
          this.commandBar.SetHiddenOption(false, 'Name', 'Retornar');
      }, 500);
    }
  }
  public Limpiar(callback: (data: any) => void = null, action?: any) {
    //debugger;
    this.modelo.modelo.Caja = null;
      this.modelo.modelo.Cara = null;
      this.modelo.modelo.Carpeta = null;
      this.modelo.modelo.Entrepano = null;
      this.modelo.modelo.Estante = null;
      this.modelo.modelo.FechaFinal = null;
      this.modelo.modelo.FechaInicial = null;
      this.modelo.modelo.Folios = null;
      this.modelo.modelo.IdUbicacionFisicaExpediente = null;
      this.modelo.modelo.Observaciones = null;
      this.modelo.modelo.CurrentItemIndex = null;
      this.modelo.modelo.PkValue = 0;

      this.SetModelToControls();

    /**
     * INICIO
     * Edward Morales 14042021-1529
     *
     * Refrescar grilla después de crud de registro, linea original comentada (91)
     */
    //debugger;
    var IdExpedienteGestion = -1;
    //if(this.utility.ReturnParentDetailsItem){
      if(this.utility.ReturnParentDetailsItem.IdExpediente){
        IdExpedienteGestion = this.utility.ReturnParentDetailsItem.IdExpediente;
      //}
    }
    super.Limpiar(callback, action);

    //this.componentsContainer.ReloadTable('DataTables_TUbicacionFisicaExpediente', { IdEmpresa: -1, IdExpediente: -1 });
    this.componentsContainer.ReloadTable('DataTables_TUbicacionFisicaExpediente', { IdEmpresa: -1, IdExpediente: IdExpedienteGestion });


    if (this.utility.ReturnParentDetailsItem) {
      this.modelo.modelo.IdExpediente = this.utility.ReturnParentDetailsItem.IdExpediente;
    }

  }
  public SetExpediente(item: any) {
    // item.ListaPermisos.Array().forEach(permisos => {
    //   permisos.Editar = true
    // });
    //debugger;
    if (item != undefined) {
      this.modelo.modeloVirtual.IdUsuarioResponsable = item.IdUsuarioResponsable;
    let ConfigPermisos = JSON.parse(item.Configuracion)
    ConfigPermisos.forEach(permisos => {
      permisos.Editar = true
    });
    item.Configuracion = JSON.stringify(ConfigPermisos);

    this.detalleExpediente = item;
    this.permissionsConfig.expediente = item;

    this.componentsContainer.SetTableProperty(
      "DataTables_TUbicacionFisicaExpediente",
      "configPermisos",
      this.permissionsConfig
    );

      this.modelo.modelo.IdExpediente = item.IdExpediente;

      /**
       * INICIO
       * Edward Morales - 14042021_1535
       * Cargar registros creados para el expediente seleccionado
       */

      if(this.detalleExpediente.IdExpediente == undefined){
        this.detalleExpediente.IdExpediente = this.modelo.modelo.IdExpediente;
      }
      this.componentsContainer.ReloadTable('DataTables_TUbicacionFisicaExpediente',
        { IdEmpresa: -1, IdExpediente: this.detalleExpediente.IdExpediente }, null, false);
        //{ IdEmpresa: -1, IdExpediente: this.modelo.modelo.IdExpediente }, null, false);
    }
    else {
      this.modelo.modelo.IdExpediente = null;
      this.componentsContainer.SetTableProperty('DataTables_TUbicacionFisicaExpediente', 'cargarGrilla', false, false);

      this.componentsContainer.ReloadTable('DataTables_TUbicacionFisicaExpediente',
      { IdEmpresa: -1, IdExpediente: -2 }, null, false);
    }
    this.RaiseFormEvent("OnUpdatePermissionsConfig", true);
  }
public OnDataTableEditHandler(event) {

    if (event && event.name == 'DataTables_BusquedaExpediente') {
      this.SetExpediente(this.modelo.expediente);
      delete this.modelo.expediente;
    }

    if (event && event.name == 'DataTables_TUbicacionFisicaExpediente' &&
      event.data && event.data.data && event.data.data.findItem) {
      this.datosArchivoFisicoEdicion = this.utility.Clone(event.data.data.findItem);
      this.edicionArchivoFisicoPendiente = true;
      super.OnDataTableEditHandler(event);
    }

  }
  public OnActionEventHandler(event) {
    //debugger;
    if (event.Option && event.Option.Name == 'DescargarFuid') {
      if (this.modelo.modelo.DataAdd) {
        this.modelo.modelo.DataAdd["Expedientes"] = this.modelo.modelo.IdExpediente;
      }
      else {
        this.modelo.modelo.DataAdd = {
          Expedientes: this.modelo.modelo.IdExpediente
        };
      }
    }
    if (event.Option && event.Option.Type == 'New') {
      this.RestablecerConfiguracionArchivoFisico();
    }
    if (
      event.Action === FormActionsThroughEmitters.ClearModel &&
      event.Table == "DataTables_BusquedaExpediente"
    ) {
      this.componentsContainer.ReloadTable(
        "DataTables_TUbicacionFisicaExpediente",
        { IdEmpresa: -1, IdExpediente: -1 }
      );
    }

    /// adicion de botones de navegacion a las paginas de documento y ubicacion
    // else if (event.Option.Type == "Return") {
    //   this.utility.router.navigate(['DetalleExpediente']);
    // }

    //Modificado Miguel Patiño (Da error cuando event.Option es undefined)
    if (event.Option) {
      if (event.Option.Type == "Return") {
        /**
       * Inicio Edward Morales 02/03/2032
       * Valida el nombre de la página entrante para posterior Retorno commandBar
       * si es null continúa proceso anterior (DetalleExpediente)
       */
        if(this.urlReturn){
          this.utility.router.navigate([this.urlReturn]);
        }else{
        this.utility.router.navigate(['DetalleExpediente']);
      }
        return;
      }
    }
    if (event.Action === FormActionsThroughEmitters.ClearModel && event.Table == 'DataTables_TUbicacionFisicaExpediente') {
      this.modelo.modelo.Caja = null;
      this.modelo.modelo.Cara = null;
      this.modelo.modelo.Carpeta = null;
      this.modelo.modelo.Entrepano = null;
      this.modelo.modelo.Estante = null;
      this.modelo.modelo.FechaFinal = null;
      this.modelo.modelo.FechaInicial = null;
      this.modelo.modelo.Folios = null;
      this.modelo.modelo.IdUbicacionFisicaExpediente = null;
      this.modelo.modelo.Observaciones = null;
      this.modelo.modelo.CurrentItemIndex = null;
      this.modelo.modelo.PkValue = 0;

      this.SetModelToControls();
      return;
    }


    //this.SetModelToControls();

    super.OnActionEventHandler(event);
  }

  public AddComponentInstanceHandler(event) {
    if (this.utility.ReturnParentDetailsItem && (event instanceof DataTableComponent)) {
      event.MsgValidationRecordManagement = this.Pagina.ConfigPage.MsgValidationRecordManagement;
      event.SearchTagRecordManagement = this.Pagina.ConfigPage.SearchTagRecordManagement;
      event.MsgReleaseRecordManagement=this.Pagina.ConfigPage.MsgReleaseRecordManagement;
			event.MsgBusyRecordManagement=this.Pagina.ConfigPage.MsgBusyRecordManagement;
      this.componentsContainer.Tables.push(event);
      if (event.name == 'DataTables_TUbicacionFisicaExpediente') {
        this.SetExpediente(this.utility.ReturnParentDetailsItem);

      }

    }

    else {

      super.AddComponentInstanceHandler(event);

    }
  }

  // ------------------------------------------------------------------------------------------
  // Fase 2 Archivo Fisico (flujo parametrizado). Todo lo de aqui abajo es no-op si
  // HabilitarArchivoFisico es false: el flujo legado (Estante/Cara/Entrepano/Caja libres)
  // continua exactamente igual.
  // ------------------------------------------------------------------------------------------

  private ActualizarVisibilidadArchivoFisico() {
    const habilitado = this.ConvertirABooleano(
      this.modelo &&
      this.modelo.modeloVirtual
        ? this.modelo.modeloVirtual.HabilitarArchivoFisico
        : false
    );
    const panel = this.Pagina && this.Pagina.ConfigPage && this.Pagina.ConfigPage.Controls
      ? this.Pagina.ConfigPage.Controls.find(x => x.Name === 'PanelUbicacion') : null;
    if (!panel || !panel.Controls) { return; }

    const divLegacy = panel.Controls.find(x => x.Name === 'DivUbicacionLegacy');
    const divParametrizado = panel.Controls.find(x => x.Name === 'DivArchivoFisicoParametrizado');

    if (divLegacy) { divLegacy.Hidden = habilitado; }
    if (divParametrizado) { divParametrizado.Hidden = !habilitado; }

    this.HabilitarFormControlsDeContenedor(divLegacy, !habilitado);
    this.HabilitarFormControlsDeContenedor(divParametrizado, habilitado);

    if (habilitado) { this.ActualizarVisibilidadCajaNueva(); }
  }

  // Cuando es caja existente (EsCajaNueva=false) se pide/usa CajaDestino; cuando es nueva, se
  // autoasigna en el backend y el campo no aplica.
  private ActualizarVisibilidadCajaNueva() {
    const divParametrizado = this.ObtenerDivArchivoFisicoParametrizado();
    if (!divParametrizado || !divParametrizado.Controls) { return; }
    const esNueva = this.ConvertirABooleano(this.modelo && this.modelo.modeloVirtual ? this.modelo.modeloVirtual.EsCajaNueva : false);
    const cajaDestino = divParametrizado.Controls.find(x => x.Name === 'NumeroCajaDestino');
    if (cajaDestino) {
      cajaDestino.Hidden = esNueva;
      const control = this.form && this.form.controls && this.form.controls['NumeroCajaDestino'];
      if (control) {
        if (esNueva) { control.disable({ emitEvent: false }); } else { control.enable({ emitEvent: false }); }
      }
    }
  }

  // Un control deshabilitado (Angular) queda excluido de this.form.value/this.form.valid, que es
  // justo lo que se necesita para que el flujo legado (HabilitarArchivoFisico=false) no falle por
  // los Required del flujo parametrizado, y viceversa.
  private HabilitarFormControlsDeContenedor(divControl: any, habilitar: boolean) {
    if (!divControl || !divControl.Controls || !this.form || !this.form.controls) { return; }
    this.utility.GetAllFormControls(divControl.Controls).forEach(control => {
      const formControl = this.form.controls[control.Name];
      if (!formControl) { return; }
      if (!habilitar || control.Disabled === true) {
        formControl.disable({ emitEvent: false });
      } else {
        formControl.enable({ emitEvent: false });
      }
    });
  }

  private ObtenerDivArchivoFisicoParametrizado(): any {
    const panel = this.Pagina && this.Pagina.ConfigPage && this.Pagina.ConfigPage.Controls
      ? this.Pagina.ConfigPage.Controls.find(x => x.Name === 'PanelUbicacion') : null;
    return panel && panel.Controls ? panel.Controls.find(x => x.Name === 'DivArchivoFisicoParametrizado') : null;
  }

  // Los campos de solo lectura (Disabled:true) no reflejan cambios de modelo por si solos: hay que
  // empujar el valor al reactive form, igual que en TArchivoFisicoComponent (Fase 1).
  private ActualizarControlDeSoloLectura(nombre: string, valor: any) {
    const control = this.form && this.form.controls && this.form.controls[nombre];
    if (control) {
      control.setValue(valor, { emitEvent: false });
    }
  }

  // Al seleccionar la bodega: puebla los displays de solo lectura y limpia la seleccion de
  // estante/cuerpo/entrepano/caja previos (dependen de la bodega elegida).
  private SetBodegaArchivoFisico(item: any) {
    if (!this.modelo.modeloVirtual) { this.modelo.modeloVirtual = {}; }

    if (!item) {
      this.modelo.modeloVirtual.IdArchivoFisico = null;
      this.modelo.modeloVirtual.EdificioBodegaDisplay = '';
      this.modelo.modeloVirtual.TipoCajaCodigoDisplay = '';
      this.modelo.modeloVirtual.CapacidadTotalDisplay = 0;
      this.modelo.modeloVirtual.CapacidadOcupadaDisplay = 0;
      this.modelo.modeloVirtual.CapacidadDisponibleDisplay = 0;
      this.modelo.modeloVirtual.PorcentajeOcupacionDisplay = 0;
      this.ActualizarControlDeSoloLectura('EdificioBodegaDisplay', '');
      this.ActualizarControlDeSoloLectura('TipoCajaCodigoDisplay', '');
      this.ActualizarControlDeSoloLectura('CapacidadTotalDisplay', 0);
      this.ActualizarControlDeSoloLectura('CapacidadOcupadaDisplay', 0);
      this.ActualizarControlDeSoloLectura('CapacidadDisponibleDisplay', 0);
      this.ActualizarControlDeSoloLectura('PorcentajeOcupacionDisplay', 0);
      this.RecargarCombosDependientesDeBodega(-1);
      return;
    }

    this.modelo.modeloVirtual.IdArchivoFisico = item.IdArchivoFisico;
    this.idArchivoFisicoSeleccionado = item.IdArchivoFisico;
    this.modelo.modeloVirtual.NumeroEstanteria = null;
    this.modelo.modeloVirtual.NumeroCuerpo = null;
    this.modelo.modeloVirtual.NumeroEntrepano = null;
    this.modelo.modeloVirtual.NumeroCajaDestino = null;
    this.RecargarCombosDependientesDeBodega(item.IdArchivoFisico);

    let configuracion: any = {};
    try {
      configuracion = item.ConfiguracionCapacidad
        ? (typeof item.ConfiguracionCapacidad === 'string' ? JSON.parse(item.ConfiguracionCapacidad) : item.ConfiguracionCapacidad)
        : {};
    } catch (error) {
      configuracion = {};
    }

    const edificio = [item.EdificioBloque, item.PisoNivel].filter(x => !!x).join(' / ');
    const tipoCajaNombre = (configuracion && configuracion.tipoCaja) ? configuracion.tipoCaja.nombre : '';
    const total = Number(item.CapacidadTotal) || 0;
    const ocupada = Number(item.CapacidadOcupada) || 0;
    const disponible = total - ocupada;
    const porcentaje = Number(item.PorcentajeOcupacion) || 0;

    this.modelo.modeloVirtual.EdificioBodegaDisplay = edificio;
    this.modelo.modeloVirtual.TipoCajaCodigoDisplay = tipoCajaNombre;
    this.modelo.modeloVirtual.CapacidadTotalDisplay = total;
    this.modelo.modeloVirtual.CapacidadOcupadaDisplay = ocupada;
    this.modelo.modeloVirtual.CapacidadDisponibleDisplay = disponible;
    this.modelo.modeloVirtual.PorcentajeOcupacionDisplay = porcentaje;
    this.modelo.modeloVirtual.TipoCajaCodigo = configuracion && configuracion.tipoCaja
      ? configuracion.tipoCaja.codigo : null;
    this.ActualizarControlDeSoloLectura('EdificioBodegaDisplay', edificio);
    this.ActualizarControlDeSoloLectura('TipoCajaCodigoDisplay', tipoCajaNombre);
    this.ActualizarControlDeSoloLectura('CapacidadTotalDisplay', total);
    this.ActualizarControlDeSoloLectura('CapacidadOcupadaDisplay', ocupada);
    this.ActualizarControlDeSoloLectura('CapacidadDisponibleDisplay', disponible);
    this.ActualizarControlDeSoloLectura('PorcentajeOcupacionDisplay', porcentaje);
  }

  // ComboBoxManager.ExecuteCascading solo encuentra combos hijos registrados por
  // SetControlsConfig, que unicamente recorre this.Pagina.ConfigPage.Controls de primer nivel.
  // Estante/Cuerpo/Entrepano/CajaDestino viven anidados dentro del SidePanel, asi que la
  // cascada automatica nunca los alcanza: se refrescan aqui manualmente con el mismo mecanismo
  // que usa el manager internamente (mutar Params y volver a invocar CargarItemsComboBox).
  private RecargarCombosDependientesDeBodega(idArchivoFisico: any) {
    const nombresCombosDependientes = ['NumeroEstanteria', 'NumeroCuerpo', 'NumeroEntrepano', 'NumeroCajaDestino'];
    const controles = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls);
    nombresCombosDependientes.forEach(nombre => {
      const control = controles.find(x => x.Name === nombre);
      const configControl = this.configs && this.configs['Config' + nombre];
      if (!configControl) { return; }

      if (!configControl.Params) { configControl.Params = {}; }
      configControl.Params.IdArchivoFisico = idArchivoFisico;
      if (configControl.QueryConfig && configControl.QueryConfig.Entity) {
        configControl.QueryConfig.Entity.IdArchivoFisico = idArchivoFisico;
      }

      if (configControl.Context) {
        configControl.Context.CargarItemsComboBox(null, true, null, true, true);
      }
    });
  }
  // Al elegir una caja existente (CodigoCaja = "Estante-Cuerpo-Entrepano-Caja"), completa las
  // cascadas de solo consulta para que el usuario vea a donde quedara asociado el expediente.
  private SetCajaDestino(item: any) {
    if (!item || !item.CodigoCaja) { return; }
    const partes = String(item.CodigoCaja).split('-').map(x => Number(x));
    if (partes.length !== 4 || partes.some(x => isNaN(x))) { return; }

    this.modelo.modeloVirtual.NumeroEstanteria = partes[0];
    this.modelo.modeloVirtual.NumeroCuerpo = partes[1];
    this.modelo.modeloVirtual.NumeroEntrepano = partes[2];
    this.modelo.modeloVirtual.NumeroCajaDestino = item.CodigoCaja;

    this.ActualizarControlDeSoloLectura('NumeroEstanteria', partes[0]);
    this.ActualizarControlDeSoloLectura('NumeroCuerpo', partes[1]);
    this.ActualizarControlDeSoloLectura('NumeroEntrepano', partes[2]);
  }

  // GetSaveModel() solo envia this.modelo.modelo (nunca modeloVirtual): sin esto el backend nunca
  // recibiria HabilitarArchivoFisico/IdArchivoFisico/NumeroEstanteria/etc.
  private ConsolidarDatosArchivoFisico() {
    const v = this.modelo.modeloVirtual || {};
    const habilitado = this.ConvertirABooleano(v.HabilitarArchivoFisico);

    this.modelo.modelo.HabilitarArchivoFisico = habilitado;
    if (!habilitado) { return; }

    this.modelo.modelo.IdArchivoFisico = v.IdArchivoFisico;
    this.modelo.modelo.NumeroEstanteria = v.NumeroEstanteria;
    this.modelo.modelo.NumeroCuerpo = v.NumeroCuerpo;
    this.modelo.modelo.NumeroEntrepano = v.NumeroEntrepano;
    this.modelo.modelo.EsCajaNueva = this.ConvertirABooleano(v.EsCajaNueva);
    this.modelo.modelo.NumeroCajaDestino = this.modelo.modelo.EsCajaNueva
      ? null : this.ObtenerNumeroCajaDestino(v.NumeroCajaDestino);
    this.modelo.modelo.TipoCajaCodigo = v.TipoCajaCodigo;
  }

  private async DeserializarDatosArchivoFisico() {
    if (!this.modelo || !this.modelo.modelo || !this.modelo.modeloVirtual) { return; }

    const modelo = this.modelo.modelo;
    const datos = this.datosArchivoFisicoEdicion || modelo;
    const idArchivoFisico = Number(datos.IdArchivoFisico || modelo.IdArchivoFisico) || 0;
    const tieneArchivoFisico = this.ConvertirABooleano(datos.TieneArchivoFisico) || idArchivoFisico > 0;

    if (!this.habilitarArchivoFisicoConfigurado || !tieneArchivoFisico) {
      this.modelo.modeloVirtual.HabilitarArchivoFisico = false;
      this.ActualizarVisibilidadArchivoFisico();
      return;
    }

    const estante = Number(datos.NumeroEstanteria || modelo.Estante) || null;
    const cuerpo = Number(datos.NumeroCuerpo || modelo.Cara) || null;
    const entrepano = Number(datos.NumeroEntrepano || modelo.Entrepano) || null;
    const numeroCaja = Number(datos.NumeroCaja || modelo.Caja) || null;
    const codigoCaja = datos.CodigoCaja || (estante && cuerpo && entrepano && numeroCaja
      ? [estante, cuerpo, entrepano, numeroCaja].join('-') : null);
    const esCajaNueva = this.ConvertirABooleano(datos.EsCajaNueva);

    this.modelo.modeloVirtual.HabilitarArchivoFisico = true;
    this.ActualizarVisibilidadArchivoFisico();
    const bodega = await this.CargarYSeleccionarComboArchivoFisico('IdArchivoFisico', idArchivoFisico);
    await this.CargarYSeleccionarComboArchivoFisico('EsCajaNueva', esCajaNueva ? 1 : 0);
    this.modelo.modeloVirtual.EsCajaNueva = esCajaNueva;
    this.ActualizarVisibilidadCajaNueva();
    await this.CargarYSeleccionarComboArchivoFisico('NumeroEstanteria', estante, idArchivoFisico);
    await this.CargarYSeleccionarComboArchivoFisico('NumeroCuerpo', cuerpo, idArchivoFisico);
    await this.CargarYSeleccionarComboArchivoFisico('NumeroEntrepano', entrepano, idArchivoFisico);
    if (!esCajaNueva && codigoCaja) {
      await this.CargarYSeleccionarComboArchivoFisico('NumeroCajaDestino', codigoCaja, idArchivoFisico);
    }
    this.ActualizarResumenBodega(bodega || datos);
  }

  private ProcesarEdicionArchivoFisico() {
    if (!this.edicionArchivoFisicoPendiente || this.edicionArchivoFisicoEnProceso ||
      !this.TieneContextosArchivoFisico()) { return; }

    this.edicionArchivoFisicoEnProceso = true;
    this.DeserializarDatosArchivoFisico().then(() => {
      this.edicionArchivoFisicoPendiente = false;
      this.edicionArchivoFisicoEnProceso = false;
    }).catch(error => {
      this.edicionArchivoFisicoEnProceso = false;
      this.utility.logger.LogError(error, null, { componentName: this.componentName, method: 'ProcesarEdicionArchivoFisico' });
    });
  }

  private TieneContextosArchivoFisico(): boolean {
    const nombres = ['IdArchivoFisico', 'EsCajaNueva', 'NumeroEstanteria', 'NumeroCuerpo', 'NumeroEntrepano'];
    return nombres.every(nombre => this.configs && this.configs['Config' + nombre] &&
      this.configs['Config' + nombre].Context);
  }

  private CargarYSeleccionarComboArchivoFisico(nombre: string, valor: any, idArchivoFisico?: number): Promise<any> {
    return new Promise(resolve => {
      const controlConfig = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => x.Name === nombre);
      const configControl = this.configs && this.configs['Config' + nombre];
      const contexto = configControl && configControl.Context;
      if (!controlConfig || !contexto || valor === null || valor === undefined) { resolve(null); return; }
      if (idArchivoFisico !== undefined) {
        configControl.Params = configControl.Params || {};
        configControl.Params.IdArchivoFisico = idArchivoFisico;
        if (configControl.QueryConfig && configControl.QueryConfig.Entity) {
          configControl.QueryConfig.Entity.IdArchivoFisico = idArchivoFisico;
        }
      }
      contexto.CargarItemsComboBox(() => {
        const item = (contexto.items || []).find(x =>
          String(x[controlConfig.PkField]) === String(valor));
        if (item) {
          this.modelo.modeloVirtual[nombre] = item[controlConfig.PkField];
          const formControl = this.form && this.form.controls ? this.form.controls[nombre] : null;
          if (formControl) { formControl.setValue(item[controlConfig.PkField], { emitEvent: false }); }
        }
        resolve(item || null);
      }, true, null, true, false);
    });
  }

  private ActualizarResumenBodega(item: any) {
    if (!item) { return; }
    let configuracion: any = {};
    try { configuracion = typeof item.ConfiguracionCapacidad === 'string' ? JSON.parse(item.ConfiguracionCapacidad) : item.ConfiguracionCapacidad || {}; }
    catch (error) { configuracion = {}; }
    const total = Number(item.CapacidadTotal) || 0;
    const ocupada = Number(item.CapacidadOcupada) || 0;
    const porcentaje = Number(item.PorcentajeOcupacion) || 0;
    const edificio = [item.EdificioBloque, item.PisoNivel].filter(x => !!x).join(' / ');
    this.modelo.modeloVirtual.EdificioBodegaDisplay = edificio;
    this.modelo.modeloVirtual.TipoCajaCodigoDisplay = configuracion.tipoCaja ? configuracion.tipoCaja.nombre : '';
    this.modelo.modeloVirtual.CapacidadTotalDisplay = total;
    this.modelo.modeloVirtual.CapacidadOcupadaDisplay = ocupada;
    this.modelo.modeloVirtual.CapacidadDisponibleDisplay = total - ocupada;
    this.modelo.modeloVirtual.PorcentajeOcupacionDisplay = porcentaje;
    this.ActualizarControlDeSoloLectura('EdificioBodegaDisplay', edificio);
    this.ActualizarControlDeSoloLectura('TipoCajaCodigoDisplay', this.modelo.modeloVirtual.TipoCajaCodigoDisplay);
    this.ActualizarControlDeSoloLectura('CapacidadTotalDisplay', total);
    this.ActualizarControlDeSoloLectura('CapacidadOcupadaDisplay', ocupada);
    this.ActualizarControlDeSoloLectura('CapacidadDisponibleDisplay', total - ocupada);
    this.ActualizarControlDeSoloLectura('PorcentajeOcupacionDisplay', porcentaje);
  }

  private ObtenerNumeroCajaDestino(valor: any): number | null {
    if (valor === null || valor === undefined || valor === '') { return null; }
    const partes = String(valor).split('-');
    const numero = Number(partes[partes.length - 1]);
    return numero > 0 ? numero : null;
  }

  private ObtenerHabilitarArchivoFisicoConfigurado(): boolean {
    const control = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls)
      .find(x => x.Name === 'HabilitarArchivoFisico');
    return this.ConvertirABooleano(control ? control.Value : false);
  }

  private RestablecerConfiguracionArchivoFisico() {
    if (!this.modelo.modeloVirtual) { this.modelo.modeloVirtual = {}; }
    this.modelo.modeloVirtual.HabilitarArchivoFisico = this.habilitarArchivoFisicoConfigurado;
    this.datosArchivoFisicoEdicion = null;
    this.edicionArchivoFisicoPendiente = false;
    this.ActualizarVisibilidadArchivoFisico();
    if (this.commandBar) {
      this.commandBar.SetHiddenOption(false, 'Type', 'New');
    }
  }

  private ActualizarBodegaDespuesDeGuardar() {
    if (!this.idArchivoFisicoSeleccionado) { return; }
    const configBodega = this.configs && this.configs.ConfigIdArchivoFisico;
    const contextoBodega = configBodega && configBodega.Context;
    if (!contextoBodega) { return; }

    contextoBodega.CargarItemsComboBox(() => {
      const bodega = contextoBodega.FindItem(this.idArchivoFisicoSeleccionado, 'IdArchivoFisico');
      if (bodega) {
        this.SetBodegaArchivoFisico(bodega);
        this.ActualizarControlDeSoloLectura('IdArchivoFisico', bodega.IdArchivoFisico);
      }
    }, true, null, true, false);
  }

  private ConvertirABooleano(valor: any): boolean {
    return valor === true ||
      valor === 1 ||
      valor === '1' ||
      String(valor).toLowerCase() === 'true';
  }
}
